import { TextButton } from "@joonapp/web-shared"
import { Button, JoonUIColor, Typography } from "@joonapp/web-shared"
import { useTranslation } from "react-i18next"

import { ParentPasscodeStep } from "../../../../../types"
import { useParentPasscodeModalStore } from "../useParentPasscodeModalStore"
const EditPasscode = () => {
  const { setStep } = useParentPasscodeModalStore()
  const { t } = useTranslation()

  return (
    <div className="flex flex-col gap-4">
      <Typography variant="bodyBold">{t("PPC_EDIT_TITLE")}</Typography>
      <Button
        text={t("PPC_CHANGE_PASSCODE_BTN")}
        onClick={() => setStep(ParentPasscodeStep.CHANGE_PASSCODE)}
        fullWidth
      />
      <TextButton onClick={() => setStep(ParentPasscodeStep.DELETE_PASSCODE)}>
        <Typography variant="bodyBold" color={JoonUIColor.semantic.alert}>
          {t("PPC_DELETE_PASSCODE_BTN")}
        </Typography>
      </TextButton>
    </div>
  )
}

export default EditPasscode
